import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path, Rect } from "react-native-svg";

export const IconExtendImage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconExtendImage"><Path d="M8 3L3 8" stroke="currentColor"/><Path d="M6.5 17.5L3 21" stroke="currentColor"/><Path d="M21 3L17.5 6.5" stroke="currentColor"/><Path d="M14 3L10.5 6.5" stroke="currentColor"/><Path d="M6.5 10.5L3 14" stroke="currentColor"/><Path d="M21 10L17.5 13.5" stroke="currentColor"/><Path d="M13.5 17.5L10 21" stroke="currentColor"/><Path d="M21 16L16 21" stroke="currentColor"/><Rect x="6.5" y="6.5" width="11" height="11" stroke="currentColor"/></CentralIconBase>;
});

export default IconExtendImage;
